import { JobTitle } from '@pflegia/data-access';
import { FunnelQuestion, FunnelQuestionCategory } from '@pflegia/types/api/funnel/questions';
import { LocalFunnelStep } from '@pflegia/ui/funnel/types';
import { FunnelAnswers } from '@pflegia/ui/pflegia/funnel/types/funnel-answers';

export const canStartOnStep: LocalFunnelStep<JobTitle, FunnelAnswers, FunnelQuestion.CanStartOn> = {
  category: FunnelQuestionCategory.AboutYou,
  key: FunnelQuestion.CanStartOn,
};
